import { Link } from "react-router-dom";

interface Neighbor {
  name: string;
  zip: string;
  slug: string;
}

interface NeighborsSectionProps {
  neighbors: Neighbor[];
}

export default function NeighborsSection({ neighbors }: NeighborsSectionProps) {
  return (
    <section className="bg-[#fefce8] py-20">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-[#064e3b] text-3xl md:text-4xl font-black text-center mb-12">
          Nearby Service Areas
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {neighbors.map((n) => (
            <Link
              key={n.slug}
              to={`/impact-windows-${n.slug}/`}
              className="group bg-white border border-[#064e3b]/15 p-6 hover:border-[#047857] transition-colors"
            >
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-[#1a1a1a] text-lg font-black">{n.name}</h3>
                <i className="ri-arrow-right-line text-[#047857] group-hover:translate-x-1 transition-transform" />
              </div>
              <p className="text-[#666666] text-sm">ZIP {n.zip}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}